// Legacy SEO barrel.
//
// 2026-09: trimmed to the six exports that kept pages actually import. The
// forty modules it used to re-export (market configs, testimonial schemas,
// dynamic sitemaps, price-table schemas) were deleted with the programmatic
// layer. Note that SEOHead / EnhancedSEOHead wrap their output in the
// react-helmet-async shim, which renders nothing in the App Router; page
// metadata comes from each route's `metadata` / `generateMetadata` export.
export { SEOHead, default } from './SEOHead';
export { EnhancedSEOHead } from './EnhancedSEOHead';
export { organizationSchema, websiteSchema, generateBreadcrumbSchema, generateFAQSchema, howToSchema } from './StructuredData';
